{
  "min": -590,
  "max": 600,
  "R": [0, 241, 241, 248, 248, 178, 232, 255, 255],
  "G": [0, 156, 156, 222, 222, 36, 51, 255, 255],
  "B": [0, 130, 130, 169, 169, 24, 37, 255, 255],
  "A": [0, 63, 105, 135, 167, 184, 228, 228, 228],
  "I": [0, 1, 52, 127, 137, 162, 172, 252, 255]
}
